<div class="menu-container">
    <menu-render [stores]="menu_stores()"></menu-render>
</div>